export default {
    name: 'Monzo Bank Card',
    template: 'bankCard-monzo',
    details: {
        color: 'Hot Coral',
        type: 'Debit'
    },
    style: {
        background: '#FF4D56',
    },
};
